// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

export const getCompanies = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "companies/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompaniesNoPagination = async () => {
  const endpoint = "companies/no-pagination/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompanyTypes = async () => {
  const endpoint = "companies/types/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createCompany = async (data) => {
  const endpoint = "companies/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompanyData = async (company_id) => {
  const endpoint = `companies/${company_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateCompanyData = async (company_id, data) => {
  const endpoint = `companies/${company_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteCompany = async (company_id) => {
  const endpoint = `companies/${company_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompanyLiteData = async (company_id) => {
  const endpoint = `companies/${company_id}/lite/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompanySidebarData = async (company_id) => {
  const endpoint = `companies/${company_id}/sidebar/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Project people of a company by role: { ACCOUNT: "<operator id>" | null, ... }.
// Roles left out are untouched, null clears the role.
export const getCompanyAssignments = async (company_id) => {
  const endpoint = `companies/${company_id}/assignments/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const setCompanyAssignments = async (company_id, data) => {
  const endpoint = `companies/${company_id}/assignments/`;
  return axiosInstance
    .put(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Scheda Marketing Mind» of a company (read-only: written by Marketing Mind
// v2 through the external API). `data` is null when the company has none.
export const getCompanyMarketingMindProfile = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-profile/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Contratto (riassunto MM)» of a company: Marketing Mind v2's summary of the contract,
// written only by Marketing Mind (external API). Internal for the operators. data: null
// when there is none yet.
export const getCompanyMarketingMindContract = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-contract/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Operators' corrections of the «Scheda Marketing Mind»: { operator_notes }.
// Marketing Mind never overwrites them and reads them before each update.
export const patchCompanyMarketingMindProfile = async (company_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-profile/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Stile e moodboard» of a company: filled by Marketing Mind v2 through the
// external API, edited by the graphic designers. Every call answers the whole
// moodboard.
export const getCompanyStyleMoodboard = async (company_id) => {
  const endpoint = `companies/${company_id}/style-moodboard/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Add an item (locked): { kind, ...its fields }; a logo or an image with `file`
// is sent as multipart.
export const addCompanyStyleMoodboardItem = async (company_id, data, file = null) => {
  const endpoint = `companies/${company_id}/style-moodboard/items/`;
  let body = data;
  let config = {};
  if (file) {
    body = new FormData();
    Object.entries(data).forEach(([key, value]) => body.append(key, value));
    body.append("file", file);
    config = { headers: { "Content-Type": "multipart/form-data" } };
  }
  return axiosInstance
    .post(endpoint, body, config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Edit an item (it becomes locked); { locked: false } gives it back to the fill.
// A font's own file goes as multipart `file`; { remove_file: true } drops it.
export const patchCompanyStyleMoodboardItem = async (company_id, item_id, data, file = null) => {
  const endpoint = `companies/${company_id}/style-moodboard/items/${item_id}/`;
  let body = data;
  let config = {};
  if (file) {
    body = new FormData();
    Object.entries(data).forEach(([key, value]) => body.append(key, value));
    body.append("file", file);
    config = { headers: { "Content-Type": "multipart/form-data" } };
  }
  return axiosInstance
    .patch(endpoint, body, config)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteCompanyStyleMoodboardItem = async (company_id, item_id) => {
  const endpoint = `companies/${company_id}/style-moodboard/items/${item_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// New order of the colours, fonts or images: { kind, ids }.
export const reorderCompanyStyleMoodboardItems = async (company_id, data) => {
  const endpoint = `companies/${company_id}/style-moodboard/items/reorder/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Proposte di Marketing Mind» of a company: what Marketing Mind v2 prepared for
// the operators (it never writes to the client). Open ones first; `status` filters
// (one or more, comma-separated); `params` adds `kind` or `board: 1` (the shadow
// cards of the client board: open contents, not promoted, not expired).
export const getCompanyMarketingMindProposals = async (company_id, status = "", params = {}) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/`;
  return axiosInstance
    .get(endpoint, { params: { ...(status ? { status } : {}), ...params } })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// An operator handles a proposal: { status, edited_body, discard_reason }.
// Answers the proposal.
export const patchCompanyMarketingMindProposal = async (company_id, proposal_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Invia attraverso il bot»: the proposal's text (and a content's images) goes to
// the client's Telegram group through the CRM's bot; a content becomes a subtask
// «In revisione» in { task_id } or { create_task } (default task when absent).
// Answers the proposal, now SENT, and a `warning` when its subtask failed.
export const sendCompanyMarketingMindProposalTelegram = async (
  company_id,
  proposal_id,
  data = {}
) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/send-telegram/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Where a proposal can become a subtask: { services: [{ id, name, tasks }], default }.
export const getCompanyMarketingMindProposalTaskOptions = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/task-options/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// A shadow card of the client board becomes a real subtask:
// { status: TODO | IN_PROGRESS | IN_REVIEW, task_id?, create_task? }.
export const promoteCompanyMarketingMindProposal = async (company_id, proposal_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/promote/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// A designer's graphic for a proposal (multipart `file`). Answers the proposal.
export const uploadCompanyMarketingMindProposalImage = async (company_id, proposal_id, file) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/images/`;
  const body = new FormData();
  body.append("file", file);
  return axiosInstance
    .post(endpoint, body, { headers: { "Content-Type": "multipart/form-data" } })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteCompanyMarketingMindProposalImage = async (
  company_id,
  proposal_id,
  image_id
) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/images/${image_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// --- Richieste grafiche to Marketing Mind v2 (back/docs/marketing-mind/graphic-requests.md §3) ---
// Everything the «Richiedi grafica» form needs: types, objectives, formats, limits, safe zones,
// ad rules, discard reasons, the client's recent campaigns, the month's usage and cost.
export const getCompanyGraphicRequestContext = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-graphic-requests/context/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Create a request (a proposal with origin REQUEST): { type, objective, subject, formats, slides,
// text_in_graphic, cta, offer, dates, references: [{ gallery_media_id, note }], due_date, urgent,
// mode, campaign_ref, title }. Answers { proposal, warnings: [string] } (201).
export const createCompanyGraphicRequest = async (company_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-graphic-requests/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Compila con l'AI»: body { form: { type, objective, objective_text, subject, formats, slides,
// text_in_graphic, cta, offer, dates, references: [{ gallery_media_id, note }], urgent, campaign_ref } }
// (only the filled fields). Answers { fields, reasons, missing, complete }: `fields` holds only what
// the AI filled. Errors: 503 (AI unavailable), 422 (refused), 429 (throttled).
export const autofillCompanyGraphicRequest = async (company_id, form) => {
  const endpoint = `companies/${company_id}/marketing-mind-graphic-requests/autofill/`;
  return axiosInstance
    .post(endpoint, { form })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Ratings of this client: average by type, format and month, best and worst images.
export const getCompanyGraphicRequestsRatingsSummary = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-graphic-requests/ratings-summary/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// The client's style corrections (feedback with a reason or a text), newest first.
export const getCompanyMarketingMindStyleCorrections = async (company_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-style-corrections/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Monthly cost cap of the graphics: { monthly_cost_cap_eur } (account of the client or admin).
export const patchCompanyMarketingMindGraphicSettings = async (company_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-graphic-settings/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// While PROMPT_READY: { brief?, prompts: { format: text } }, the prompts MMv2 must use.
// Answers the proposal, now QUEUED (or ON_HOLD).
export const confirmCompanyMarketingMindProposalPrompt = async (company_id, proposal_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/confirm-prompt/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Decision or comment on a version: { outcome: APPROVED, image_ids? } | { outcome: CHANGES_REQUESTED,
// text, keep? } | { outcome: DISCARDED, reason, text? } | { outcome: COMMENT, text }.
// Answers the proposal.
export const sendCompanyMarketingMindVersionFeedback = async (
  company_id,
  proposal_id,
  version_id,
  data
) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/versions/${version_id}/feedback/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Same body as above plus an optional `version_id` (default: the latest version). For the
// spontaneous MM proposals without versions: the backend wraps their images into v1 first.
// Answers the proposal.
export const sendCompanyMarketingMindProposalFeedback = async (company_id, proposal_id, data) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/feedback/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// The operator's rating of an image (one per operator, editable): body { stars: 1..5,
// comment?, reasons?: [code] }. A missing key leaves that field as it is, a present one
// replaces it ("" / [] clear it). Call it as (company, proposal, image, stars, comment?,
// reasons?) or, as before, (company, proposal, image, { stars, comment? }). Answers the
// proposal.
export const putCompanyMarketingMindImageRating = async (
  company_id,
  proposal_id,
  image_id,
  stars,
  comment,
  reasons
) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/images/${image_id}/rating/`;
  const data =
    stars && typeof stars === "object"
      ? stars
      : {
          stars,
          ...(typeof comment === "string" ? { comment } : {}),
          ...(Array.isArray(reasons) ? { reasons } : {}),
        };
  return axiosInstance
    .put(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteCompanyMarketingMindImageRating = async (company_id, proposal_id, image_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/images/${image_id}/rating/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// From FAILED: back in the queue, with the edited prompts { prompts? }.
export const retryCompanyMarketingMindProposal = async (company_id, proposal_id, data = {}) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/retry/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// From ON_HOLD (account of the client or admin): one generation over the monthly cap.
export const approveCompanyMarketingMindProposalBudget = async (company_id, proposal_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/approve-budget/`;
  return axiosInstance
    .post(endpoint, {})
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Adds the image to the client's moodboard as a designer's (locked) reference image.
export const markCompanyMarketingMindImageAsReference = async (
  company_id,
  proposal_id,
  image_id
) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/images/${image_id}/use-as-reference/`;
  return axiosInstance
    .post(endpoint, {})
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// The events of a request (who, what, when).
export const getCompanyMarketingMindProposalHistory = async (company_id, proposal_id) => {
  const endpoint = `companies/${company_id}/marketing-mind-proposals/${proposal_id}/history/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getSocialLinks = async (company_id) => {
  const endpoint = `companies/${company_id}/social-links/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const postSocialLink = async (company_id, data) => {
  const endpoint = `companies/${company_id}/social-links/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const patchSocialLink = async (link_id, data) => {
  const endpoint = `companies/social-links/${link_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSocialLink = async (link_id) => {
  const endpoint = `companies/social-links/${link_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const syncPaymentsByOmpId = async (omp_id) => {
  const endpoint = `companies/payments/sync/${omp_id}/`;
  return axiosInstance
    .post(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getCompanyPayments = async (company_id, queryParams = {}) => {
  let endpoint = `companies/${company_id}/payments/`;
  endpoint = addQueryParams(endpoint, queryParams);
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Client (CU) users: companies they can switch between in the read-only portal
export const getClientPortalCompanies = async () => {
  const endpoint = `companies/client-portal/companies/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Client accesses of a company (read-only portal logins, one per client user)
export const getClientAccesses = async (company_id) => {
  const endpoint = `companies/${company_id}/client-access/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createClientAccess = async (company_id, data) => {
  const endpoint = `companies/${company_id}/client-access/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const revokeClientAccess = async (company_id, access_id) => {
  const endpoint = `companies/${company_id}/client-access/${access_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Client users (one login, many companies)
export const getClientUsers = async (queryParams = {}) => {
  const endpoint = addQueryParams("companies/client-users/", queryParams);
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createClientUser = async (data) => {
  const endpoint = "companies/client-users/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateClientUser = async (user_id, data) => {
  const endpoint = `companies/client-users/${user_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteClientUser = async (user_id) => {
  const endpoint = `companies/client-users/${user_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const resetClientUserPassword = async (user_id, data) => {
  const endpoint = `companies/client-users/${user_id}/password/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// «Avvio Marketing Mind» (docs/marketing-mind/readiness.md): the roadmap with its phases and
// steps, the per-client checks and the operators' «Segna fatto» / notes.
// Params: scope ("all": every ACTIVE client; default the clients followed by MM)
export const getMarketingMindRoadmap = async (queryParams = {}) => {
  return axiosInstance
    .get(addQueryParams("companies/marketing-mind-readiness/roadmap/", queryParams))
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// Params: scope, status, mine, team, search, incomplete, missing, limit, offset. `nextUrl` (the
// pagination's next link) wins over the params.
export const getMarketingMindReadiness = async (queryParams = {}, nextUrl = null) => {
  const endpoint = nextUrl || addQueryParams("companies/marketing-mind-readiness/", queryParams);
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getCompanyMarketingMindReadiness = async (company_id) => {
  return axiosInstance
    .get(`companies/${company_id}/marketing-mind-readiness/`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// { key, kind: "DONE" | "NOTE", text }
export const createCompanyMarketingMindReadinessNote = async (company_id, data) => {
  return axiosInstance
    .post(`companies/${company_id}/marketing-mind-readiness/notes/`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
